import request from "../utils/request";

export function findProtocol(protocol, params = {}) {
  return request({
    url: `/protocol/${protocol}`,
    method: "get",
    params,
  });
}

export function getProtocolLogs(protocol) {
  return request({
    url: `/protocol/${protocol}/logs`,
    method: "get",
  });
}
